import { useState, useRef } from "react";
import { getImageUrl } from "../../../utils/media";
import { UploadImageIcon } from "../../../assets/UploadImageIcon";
import "./style.css";

function getIniciais(nome) {
  if (!nome) return "";
  return nome
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((parte) => parte[0].toUpperCase())
    .join("");
}

function getGroupName(group) {
  return typeof group === "string" ? group : group?.name || "";
}

export default function Equipe({ team, groupLabel, groupOptions, editMode, onError, onChange }) {
  const titulo = team?.title ?? "Equipe";
  const membros = team?.members || [];
  const grupos = (
    groupOptions?.length
      ? groupOptions
      : team?.categories?.length
        ? team.categories
        : groupLabel
          ? [groupLabel]
          : []
  )
    .map(getGroupName)
    .filter(Boolean);
  const [grupoAtivo, setGrupoAtivo] = useState(0);
  const [membroUpload, setMembroUpload] = useState(null);
  const fileInputRef = useRef(null);
  const primeiroGrupoNome = grupos[0] || "";
  const grupoAtivoNome = grupos[grupoAtivo] || primeiroGrupoNome;
  const categoriasAtualizadas = grupos.map((name, index) => ({
    name,
    order: index,
  }));
  const getMemberCategory = (membro) => {
    const category = getGroupName(membro?.category);
    return grupos.includes(category) ? category : primeiroGrupoNome;
  };
  const normalizeMembersCategories = (items) =>
    items.map((membro) => ({
      ...membro,
      category: getMemberCategory(membro),
    }));
  const membrosDoGrupo = membros
    .map((membro, index) => ({ membro, index }))
    .filter(({ membro }) => getMemberCategory(membro) === grupoAtivoNome);

  const handleAdicionar = () => {

    const novoItem = {
      category: grupoAtivoNome,
      photo: null,
      name: "",
      role: ""
    };

    onChange({
      ...team,
      categories: categoriasAtualizadas,
      members: [...normalizeMembersCategories(membros), novoItem],
    });
  };

  const handleRemover = (i) => {

    const itemsAtualizados = membros.map((item, index) =>
      index === i
        ? { ...item, markedForDeletion: !item.markedForDeletion }
        : item,
    );

    onChange({
      ...team,
      categories: categoriasAtualizadas,
      members: normalizeMembersCategories(itemsAtualizados),
    });
  };

  const handleMemberChange = (i, field, value) => {
    const itemsAtualizados = membros.map((item, index) =>
      index === i ? { ...item, [field]: value } : item,
    );

    onChange({
      ...team,
      categories: categoriasAtualizadas,
      members: normalizeMembersCategories(itemsAtualizados),
    });
  };

  const handleImageUpload = (i, file) => {
    if (!file) return;

    const previewUrl = URL.createObjectURL(file);

    const itemsAtualizados = membros.map((membro, index) =>
      index === i
        ? {
          ...membro,
          photo: { url: previewUrl },
          newFile: file,
        }
        : membro
    );

    onChange({
      ...team,
      categories: categoriasAtualizadas,
      members: normalizeMembersCategories(itemsAtualizados),
    });
  };



  if (editMode) {
    return (
      <section className="equipe">
        <div className="equipe__cabecalho">
          <input
            className="quem-somos-page-h2__input"
            value={titulo || ""}
            onChange={(e) => onChange({ ...team, title: e.target.value })}
          />
          <div style={{ display: "flex", alignItems: "center", justifyContent: "end" }}>
            <button
              type="button"
              className="equipe-membro__add-btn"
              onClick={handleAdicionar}
            >
              + Adicionar membro{grupoAtivoNome ? ` em ${grupoAtivoNome}` : ""}
            </button>
          </div>
          {grupos.length > 0 && (
            <div className="equipe__grupos" aria-label="Grupos da equipe">
              {grupos.map((grupo, index) => (
                <button
                  key={grupo}
                  type="button"
                  className={`equipe__grupo ${grupoAtivo === index ? "equipe__grupo--ativo" : ""
                    }`}
                  onClick={() => setGrupoAtivo(index)}
                  aria-pressed={grupoAtivo === index}
                >
                  {grupo}
                </button>
              ))}
            </div>
          )}
        </div>

        {membrosDoGrupo.length === 0 ? (
          <p className="equipe__vazio">Em breve, a equipe será exibida aqui.</p>
        ) : (
          <div className="equipe__grade">
            {membrosDoGrupo.map(({ membro, index }) => (
              <div key={index}
                className="equipe__membro"
              >
                <div className="equipe__foto">
                  {membro.previewUrl || getImageUrl(membro.photo) ? (
                    <img src={membro.previewUrl || getImageUrl(membro.photo)} alt={membro.name} />
                  ) : (
                    <div className="equipe__foto-placeholder">
                      {getIniciais(membro.name)}
                    </div>
                  )}
                </div>
                <input
                  type="file"
                  accept="image/*"
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  onChange={(e) => {
                    handleImageUpload(membroUpload, e.target.files[0]);
                    e.target.value = "";
                  }}
                />
                <button
                  type="button"
                  className="upload-image-btn"
                  onClick={() => {
                    setMembroUpload(index);
                    fileInputRef.current?.click();
                  }}
                >
                  <UploadImageIcon />
                </button>
                <textarea style={{
                  height: "30px", fontSize: "0.9rem", marginBottom: "3px",
                  color: "#1a56a8", background: membro.markedForDeletion ? "#f73434" : ""
                }}
                  className="quem-somos-page-p__textarea"
                  value={membro.name || ""}
                  placeholder="Ex.: Fulano"
                  onChange={(e) => handleMemberChange(index, "name", e.target.value)}
                />
                <textarea style={{
                  height: "50px", fontSize: "0.9rem", marginBottom: "0px",
                  color: "#35537f", background: membro.markedForDeletion ? "#f73434" : ""
                }}
                  className="quem-somos-page-p__textarea"
                  value={membro.role || ""}
                  placeholder="Ex.: Diretor"
                  onChange={(e) => handleMemberChange(index, "role", e.target.value)}
                />
                <button
                  type="button"
                  className="equipe-membro__remover-btn"
                  onClick={() => handleRemover(index)}
                >
                  {membro?.markedForDeletion ? "Desfazer remoção" : "Remover"}
                </button>
              </div>
            ))}
          </div>
        )}
      </section>
    );
  }

  return (
    <section className="equipe">
      <div className="equipe__cabecalho">
        <h2 className="equipe__titulo">{titulo}</h2>

        {grupos.length > 0 && (
          <div className="equipe__grupos" aria-label="Grupos da equipe">
            {grupos.map((grupo, index) => (
              <button
                key={grupo}
                type="button"
                className={`equipe__grupo ${grupoAtivo === index ? "equipe__grupo--ativo" : ""
                  }`}
                onClick={() => setGrupoAtivo(index)}
                aria-pressed={grupoAtivo === index}
              >
                {grupo}
              </button>
            ))}
          </div>
        )}
      </div>

      {membrosDoGrupo.length === 0 ? (
        <p className="equipe__vazio">Em breve, a equipe será exibida aqui.</p>
      ) : (
        <div className="equipe__grade">
          {membrosDoGrupo.map(({ membro, index }) => (
            <div key={membro._id || index} className="equipe__membro">
              <div className="equipe__foto">
                {getImageUrl(membro.photo) ? (
                  <img src={getImageUrl(membro.photo)} alt={membro.name} />
                ) : (
                  <div className="equipe__foto-placeholder">
                    {getIniciais(membro.name)}
                  </div>
                )}
              </div>
              <strong className="equipe__nome">{membro.name}</strong>
              <span className="equipe__cargo">{membro.role}</span>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
